"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLowestDisplayOrder = void 0;
// eslint-disable-next-line @typescript-eslint/ban-types --- we need this type api definition is null, undefined or is not defined

const getLowestDisplayOrder = fields => {
  let lowestDisplayOrder = null;
  for (const fieldKey in fields) {
    if (Object.prototype.hasOwnProperty.call(fields, fieldKey)) {
      const customField = fields[fieldKey];
      if (!customField || typeof customField !== 'object') {
        continue;
      }
      if (!('displayOrder' in customField)) {
        continue;
      }
      const {
        displayOrder
      } = customField;
      if (typeof displayOrder !== 'number') {
        continue;
      }
      if (displayOrder && (lowestDisplayOrder === null || displayOrder < lowestDisplayOrder)) {
        lowestDisplayOrder = displayOrder;
      }
    }
  }
  return lowestDisplayOrder;
};
exports.getLowestDisplayOrder = getLowestDisplayOrder;
